<template>
  <orgqueues />
</template>

<script>
  import orgqueues from '../components/OrgQueues.vue'

  export default {
    name: 'orgqueues',

    components: {
      orgqueues,
    },
  }
</script>
